
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 340 255","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 176H0h25v54h290v-54h25v79H0V0h340v176h-25V25H25v151z","fill":"#9d9d9d"}}),_c('path',{attrs:{"d":"M.469-.026L339.936 254.53M340.154-.03L-.151 254.754","fill":"none","stroke":"#9d9d9d","stroke-width":"5"}}),_c('text',{attrs:{"x":"120.632","y":"84.906","font-family":"Courier","font-size":"32","fill":"gray","transform":"translate(10.704 -3.972)"}},[_v('Bild')]),_c('text',{attrs:{"x":"114.024","y":"84.906","font-family":"Courier","font-size":"32","fill":"gray","transform":"translate(7.335 109.032)"}},[_v('fehlt')])])
          )
        }
      }
    